module.exports = __webpack_public_path__ + "img/zhoubaodingyue2.20748319.jpg";